import React, { useState } from 'react'
import MaterialTable, { MTableToolbar } from "material-table";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-sliding-pane/dist/react-sliding-pane.css";
import _ from "lodash";


import { getTrans as t } from "../../Localization/translations";
import { API } from '../../backend';
import authHeader from '../../services/auth-header';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable'


const Categories = ({ customerPermission }) => {
        const CategorytableRef = React.createRef();
    
    // const [loading, setLoading] = useState(false);
      const [permissionss, setPermission] = useState(
        localStorage.getItem("permissions")
      );
      const permissionsArray = permissionss.split(",");
        let navigate = useNavigate();
      
      const handleEdit = (id) => {
        navigate("/editcategories", { state: id });
      };
      const handleView = (id) =>{
        navigate("/viewcategories", { state: id });
      }
    return (
        <>
            {/* {loading === false ? ( */}
            <div className="page-wrapper">
                <ToastContainer />
                <div className="content container-fluid">
                    <div className="row">
                        <div className="">
                            <div className="ms-auto my-auto mt-lg-0 mt-4">
                                <div className="ms-auto my-auto"></div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="">
                                <div className="body">
                                    <div className="p-0">
                                        <MaterialTable
                                            tableRef={CategorytableRef}
                                            style={{
                                                backgroundColor: "var(--bs-table-bg)",
                                                borderBottomWidth: "1px",
                                                boxShadow:
                                                    "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                            }}
                                            title={
                                                <h5 className="d-lg-flex">{t("Categories")}</h5>
                                            }
                                            columns={[
                                                {
                                                    title: `${t("Category ID")}`,
                                                    field: "category_id",
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Category ID")}{" "}
                                                            </div>
                                                            <div className="hyperlink"
                                                            onClick={()=> handleView(rowData.id)}
                                                            >
                                                                {rowData.id}
                                                            </div>
                                                        </>
                                                    ),
                                                },
                                                {
                                                    title: `${t("Category Name")}`,
                                                    field: "category_name",
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Category Name")}{" "}
                                                            </div>
                                                            <div>
                                                                {rowData.category_name}
                                                            </div>
                                                        </>
                                                    ),
                                                },
                                                {
                                                  title: `${t("Sub Category Name")}`,
                                                  field: "sub_category_name",
                                                  headerStyle: {
                                                      verticalAlign: "inherit",
                                                      fontWeight: "bold",
                                                      textAlign: "left",
                                                  },
                                                  cellStyle: {
                                                      textAlign: "left",
                                                      fontSize: 12,
                                                  },
                                                  render: (rowData) => (
                                                      <>
                                                          <div className="d-xl-none tc d-md-none d-lg-none">
                                                              {t("Sub Category Name")}{" "}
                                                          </div>
                                                          <div>
                                                              {rowData.sub_category_name}
                                                          </div>
                                                      </>
                                                  ),
                                              },
                                              
                                            ]}
                                            data={(query) =>
                                                new Promise((resolve, reject) => {
                                                    let url = API + "contracts/categories/?";
                                                    url += "per_page=" + query.pageSize;
                                                    url += "&page=" + (query.page + 1);
                                                    url += "&search=" + query.search;
                                                    // url += `&itemname=${
                                                    //   selectedValue ? selectedValue.itemname : ""
                                                    // }`;
                                                    // url += `&serialnumber=${
                                                    //   selectedValue2 ? selectedValue2.serialnumber : ""
                                                    // }`;
                                                    // url += `&model=${
                                                    //   selectedValue3 ? selectedValue3.model : ""
                                                    // }`;
                                                    // url += `&make=${
                                                    //   selectedValue4 ? selectedValue4.make : ""
                                                    // }`;
                                                    // url += `&status=${
                                                    //   selectedValue5 ? selectedValue5.status : ""
                                                    // }`;
                                                    // url += `&manufacturer=${
                                                    //   selectedValue6 ? selectedValue6.manufacturer : ""
                                                    // }`;
                                                    // url += `&item_type=${
                                                    //   asset_type ? asset_type : ""
                                                    // }`;
                                                    fetch(url, { headers: authHeader() })
                                                        .then((response) => response.json())
                                                        .then((result) => {
                                                            resolve({
                                                                data:
                                                                    query.orderBy && query.orderDirection
                                                                        ? _.orderBy(
                                                                            result.data.categories,
                                                                            [query.orderBy.field],
                                                                            [query.orderDirection]
                                                                        )
                                                                        : result.data.categories,
                                                                page: result.page - 1,
                                                                totalCount: result.total,
                                                            });
                                                        });
                                                })
                                            }
                                            localization={{
                                                toolbar: {
                                                    searchPlaceholder: "Search Category",
                                                },
                                            }}
                                            actions={[
                                              (rowData)=>({
                                                icon: () => (

                                                     permissionss &&  permissionsArray.includes('change_category')===true ?
                                                  <img
                                                    src={
                                                      process.env.PUBLIC_URL +
                                                      "/static/images/ic-edit.svg"
                                                    }
                                                    alt="edit"
                                                  />
                                                  :""
                                                ),
                                                tooltip: "Edit",
                                                onClick: permissionss &&  permissionsArray.includes('change_category')===true ? (event, rowData) => {
                                                  handleEdit(rowData.id);
                                                }:"",

                                              })
                                              // {
                                              //   icon: () => (
                                              //     permissionss &&  permissionsArray.includes('delete_itemmaster')===true ?
                                              //     <img
                                              //       src={
                                              //         process.env.PUBLIC_URL +
                                              //         "/static/images/ic-delete.svg"
                                              //       }
                                              //       alt="delete"
                                              //     />:""
                                              //   ),
                                              //   tooltip: "Delete",
                                              //   onClick: permissionss &&  permissionsArray.includes('delete_itemmaster')===true ? (event, rowData) => {
                                              //     handelDelete(rowData.id);
                                              //   }:"",
                                              // },
                                            ]}
                                            components={{
                                                Toolbar: (props) => (
                                                    <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                                                        <MTableToolbar {...props} />
                                                        {/* <span
                                    onClick={() => setState({ isPaneOpen: true })}
                                    style={{
                                      color: "#b4b7c5",
                                      paddingRight: "1px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/static/images/ic-filter.svg"
                                      }
                                      alt="filter"
                                    />
                                  </span> */}
                                                        {
                                                            permissionss && permissionsArray.includes('add_category') === true ?
                                                                customerPermission !== 'Customer' &&
                                                                <Link
                                                                    className="navbar-brand m-0"
                                                                    to="/addcategories"
                                                                >
                                                                    <button
                                                                        className="add-party add btn btn-primary  mb-0"
                                                                        id="add-task"
                                                                    >
                                                                        +&nbsp; {t("Add Category")}
                                                                    </button>
                                                                </Link>
                                                                : ""
                                                        }
                                                    </div>
                                                ),
                                            }}
                                            options={{
                                                headerStyle: {
                                                    backgroundColor: "white",
                                                    color: "#245C7F",
                                                    fontSize: 12,
                                                },
                                                rowStyle: (rowData, index) => {
                                                    if (index % 2) {
                                                        return { backgroundColor: "#fff" };
                                                    }
                                                },
                                                sorting: true,
                                                search: true,
                                                toolbar: true,
                                                paging: true,
                                                pageSize: 10, // make initial page size
                                                emptyRowsWhenPaging: false, // To avoid of having empty rows
                                                pageSizeOptions: [10, 20, 25, 50],
                                                paginationType: "stepped",
                                                showFirstLastPageButtons: false,
                                                exportAllData: true,
                                                exportButton: true,
                                                exportFileName: "Inventory",
                                                exportPdf: (data, columns) => {
                                                    const doc = new jsPDF();
                                                    const columnTitles = data.map(
                                                        (columnDef) => columnDef.title
                                                    );

                                                    const pdfData = columns.map((rowData) =>
                                                        data.map(
                                                            (columnDef) => rowData[columnDef.field]
                                                        )
                                                    );
                                                    // doc.autoTable({
                                                    autoTable(doc,{
                                                        head: [columnTitles],
                                                        body: pdfData,
                                                    });

                                                    doc.save(`Inventory.pdf`);
                                                },
                                                actionsColumnIndex: -1,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/*     
                    <SlidingPane
                      className="some-custom-class"
                      overlayClassName="some-custom-overlay-class"
                      isOpen={state1.isPaneOpen}
                      title="Filter By"
                      onRequestClose={() => {
                        setState({ isPaneOpen: false });
                      }}
                    >
                      <div className="col-md-12">
                        <div className="">
                          <div className="">
                            <label className="col-lg-12 col-form-label">
                              {t("Item Number")}
                            </label>
                            <div className="col-lg-12 mb-3">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                placeholder={t("Search for Item Number (%for All)")}
                                value={selectedValue}
                                getOptionLabel={(e) => e.itemname}
                                getOptionValue={(e) => e.itemname}
                                loadOptions={loadOptions}
                                onInputChange={handelInputChange}
                                onChange={handelChange}
                              ></AsyncSelect>
                            </div>
                          </div>
                        </div>
    
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Serial Number")}
                            </label>
                            <div className="col-lg-12">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                placeholder={t(
                                  "Search for Serial number(%for All)"
                                )}
                                value={selectedValue2}
                                getOptionLabel={(e) => e.serialnumber}
                                getOptionValue={(e) => e.serialnumber}
                                loadOptions={loadOptions2}
                                onInputChange={handelInputChange2}
                                onChange={handelChange2}
                              ></AsyncSelect>
                            </div>
                            <input type="hidden" id="contract_status" value="" />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Model")}
                            </label>
                            <div className="col-lg-12">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                placeholder={t("Search for Model(%for All)")}
                                value={selectedValue3}
                                getOptionLabel={(e) => e.model}
                                getOptionValue={(e) => e.model}
                                loadOptions={loadOptions3}
                                onInputChange={handelInputChange3}
                                onChange={handelChange3}
                              ></AsyncSelect>
                            </div>
                            <input type="hidden" id="contract_status" value="" />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Make")}
                            </label>
                            <div className="col-lg-12">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                placeholder={t("Search for Make(%for All)")}
                                value={selectedValue4}
                                getOptionLabel={(e) => e.make}
                                getOptionValue={(e) => e.make}
                                loadOptions={loadOptions4}
                                onInputChange={handelInputChange4}
                                onChange={handelChange4}
                              ></AsyncSelect>
                            </div>
                            <input type="hidden" id="contract_status" value="" />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Status")}
                            </label>
                            <div className="col-lg-12">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                placeholder={t("Search for Status(%for All)")}
                                value={selectedValue5}
                                getOptionLabel={(e) => e.status}
                                getOptionValue={(e) => e.status}
                                loadOptions={loadOptions5}
                                onInputChange={handelInputChange5}
                                onChange={handelChange5}
                              ></AsyncSelect>
                            </div>
                            <input type="hidden" id="contract_status" value="" />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Manufacture")}
                            </label>
                            <div className="col-lg-12">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                placeholder={t("Search for Manufacture(%for All)")}
                                value={selectedValue6}
                                getOptionLabel={(e) => e.manufacturer}
                                getOptionValue={(e) => e.manufacturer}
                                loadOptions={loadOptions6}
                                onInputChange={handelInputChange6}
                                onChange={handelChange6}
                              ></AsyncSelect>
                            </div>
                            <input type="hidden" id="contract_status" value="" />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="form-group row">
                            <label className="col-lg-12 col-form-label">
                              {t("Item Type")}
                            </label>
                            <div className="col-lg-12">
                            <select
                                className="form-control"
                                name="item_type"
                                value={asset_type}
                                onChange={(e) => setAsset_type(e.target.value)}
                              >
                                <option value="">Select Value</option>
                                <option value="Vehicle">Vehicle</option>
                                <option value="Equipment">Equipment</option>
                              </select>
                            </div>
                            <input type="hidden" id="contract_status" value="" />
                          </div>
                        </div>
    
                        <div className="col-lg-12">
                          <button
                            type="button"
                            className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                            // onClick={handleClear}
                          >
                            {t("Reset")}
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            onClick={handelSearch}
                            className="partyFilter add btn btn-primary ms-auto mb-0"
                          >
                            {t("Apply")}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </SlidingPane> */}
                        </div>
                    </div>
                </div>
            </div>
             {/* ) : (
            <ContentLoader
              viewBox="0 0 1000 550"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )} */}
        </>
    )
}

export default Categories